// assets
import {
  ProjectOutlined,
  FolderOpenOutlined,
  TeamOutlined,
  DollarOutlined,
  FileTextOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
  BankOutlined
} from '@ant-design/icons';

// icons
const icons = {
  ProjectOutlined,
  FolderOpenOutlined,
  TeamOutlined,
  DollarOutlined,
  FileTextOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
  BankOutlined
};

const pages = {
  id: 'admin',
  title: '',
  type: 'group',
  roles: ['admin'], // Only admins can see this group
  children: [
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/admin/users',
      icon: icons.TeamOutlined
    },
    {
      id: 'projects',
      title: 'Projects',
      type: 'item',
      url: '/admin/projects',
      icon: icons.ProjectOutlined
    },
    {
      id: 'invoices',
      title: 'Vendor Invoices',
      type: 'item',
      url: '/admin/invoices',
      icon: icons.FolderOpenOutlined
    },
    {
      id: 'opex-invoices',
      title: 'OPEX Invoices',
      type: 'item',
      url: '/admin/opex-invoices',
      icon: icons.FileTextOutlined
    },
    {
      id: 'client-invoices',
      title: 'Client Invoices',
      type: 'item',
      url: '/admin/client-invoices',
      icon: icons.FileTextOutlined
    },
    {
      id: 'payments',
      title: 'Payments',
      type: 'item',
      url: '/admin/payments',
      icon: icons.DollarOutlined
    },
    {
      id: 'vendors-bank-accounts',
      title: 'Vendors Bank Accounts',
      type: 'item',
      url: '/admin/vendors-bank-accounts',
      icon: icons.BankOutlined
    },
    {
      id: 'timetracking',
      title: 'Time Tracking',
      type: 'item',
      url: '/admin/timetracking',
      icon: icons.ClockCircleOutlined,
      requiredFeature: 'time_tracking'
    },
    {
      id: 'vacation',
      title: 'Time Off Management',
      type: 'item',
      url: '/admin/vacation',
      icon: icons.CalendarOutlined,
      requiredFeature: 'vacation_tracking'
    }
  ]
};

export default pages;
